import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpHandler, HttpRequest } from '@angular/common/http';
import * as moment from 'moment-timezone';
/** Pass untouched request through to the next request handler. */

@Injectable({
  providedIn: 'root'
})
export class TimeZoneInterceptor implements HttpInterceptor {
  constructor() {}

  // tslint:disable-next-line: no-any
  intercept(req: HttpRequest<any>, next: HttpHandler) {
    if (req.url.indexOf('geocode.arcgis.com') >= 0) {
      return next.handle(req);
    } else {
      // Get the auth token from the service.
      const res = moment.tz.guess();

      // Clone the request and replace the original headers with
      // cloned headers, updated with the authorization.
      const authReq = req.clone({
        headers: req.headers.set('TimeZone', res)
      });

      // send cloned request with header to the next handler.
      return next.handle(authReq);
    }
  }
}
